angular.module('FlexyBeautyApp.services')
    .factory('CompanyType', ['gettextCatalog',function (gettextCatalog) {
        let labelSc = gettextCatalog.getString("Salon de coiffure"),
            labelIb = gettextCatalog.getString("Institut de beauté"),
            labelSpa = gettextCatalog.getString("SPA"),
            labelAutre = gettextCatalog.getString("Autre"),
            labelLoreal = gettextCatalog.getString("Salon de coiffure l'Oréal")

        return {
            HAIRDRESSING_SALON       :{id: '1', label: labelSc},
            BEAUTY_INSTITUTE         :{id: '2', label: labelIb},
            SPA                      :{id: '3', label: labelSpa},
            OTHER                    :{id: '4', label: labelAutre},
            LOREAL_HAIR_SALON        :{id: '5', label: labelLoreal}
        };
    }]);


// WEBPACK FOOTER //
// ./js/services/views/ConstantsCompanyType.js